import { patientIhiClient } from '@/api/patients/patientIhiClient';
import { prescribeClient, prescribedProductClient } from '@/api/prescribedProducts/prescribedProductClient';
import { tsrContractsClient } from '../api/tsrContractsClient';

const { ReactQueryProvider: TsrReactQueryAppProvider } = tsrContractsClient;

// @todo migrate to new Xapi contracts
const { ReactQueryProvider: TsrReactQueryPrescribedProductProvider } = prescribedProductClient;
const { ReactQueryProvider: TsrReactQueryPrescribeClientProvider } = prescribeClient;
const { ReactQueryProvider: TsrReactQuerypatientIhiClientProvider } = patientIhiClient();

export const TsrReactQueryProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <TsrReactQueryAppProvider>
      <TsrReactQueryPrescribedProductProvider>
        <TsrReactQueryPrescribeClientProvider>
          <TsrReactQuerypatientIhiClientProvider>{children}</TsrReactQuerypatientIhiClientProvider>
        </TsrReactQueryPrescribeClientProvider>
      </TsrReactQueryPrescribedProductProvider>
    </TsrReactQueryAppProvider>
  );
};
